<!--
 * @Author: Nemo
 * @Description: 国家选择组件
 * @Date: 2024-05-14
 * @FilePath: /rhcn-checkout-web/src/componentsV2/busi/country-select/index.vue
-->
<template>
  <div class="country-select-container">
    <OnSelect
      :value="value"
      :options="countryOptions"
      :placeholder="placeholder"
      :disabled="disabled"
      :error="error"
      :required="required"
      @input="handleInput"
      @change="handleChange"
      @focus="handleFocus"
      @blur="handleBlur"
    />
  </div>
</template>

<script>
import OnSelect from '@/componentsV2/base/select/index.vue';
import countries from '@/utils/tools/country.js';

export default {
  name: 'CountrySelect',
  components: {
    OnSelect,
  },
  props: {
    // 当前选中的国家代码
    value: {
      type: String,
      default: '',
    },
    // 占位符文本
    placeholder: {
      type: String,
      default: '',
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 是否错误状态
    error: {
      type: Boolean,
      default: false,
    },
    // 是否必填
    required: {
      type: Boolean,
      default: false,
    },
    // 是否只显示部分常用国家
    onlyCommon: {
      type: Boolean,
      default: false,
    },
    // 自定义常用国家代码列表
    commonCountries: {
      type: Array,
      default: () => ['CN', 'US', 'GB', 'JP', 'DE', 'AU', 'CA', 'FR', 'IT', 'ES', 'SG', 'HK', 'TW'],
    },
  },
  data() {
    return {
      countryList: [],
    };
  },
  created() {
    this.initCountryList();
  },
  computed: {
    // 当前语言
    lang() {
      return this.$i18n.locale;
    },
    // 转换国家数据为下拉选项格式
    countryOptions() {
      let countryList = [...this.countryList];

      // 如果只显示常用国家
      if (this.onlyCommon) {
        countryList = countryList.filter(country =>
          this.commonCountries.includes(country.code),
        );
      }

      // 转换为OnSelect需要的格式
      return countryList.map(country => ({
        value: country.code,
        label: country.label,
      }));
    },
  },
  methods: {
    // 初始化国家列表并支持多语言
    initCountryList() {
      this.countryList = countries.map(item => ({
        ...item,
        code: item.code,
        label: this.$t(`message.country.${item.code}`),
      })).sort((s1, s2) => {
        try {
          const l = (this.lang === 'zh-tw' || this.lang === 'zh-cn') ? 'zh' : this.lang;
          return s1.label.localeCompare(s2.label, l, { ignorePunctuation: true });
        } catch (err) {
          // 排序出错时的默认处理
        }
        return 1;
      });
    },
    // 处理输入事件
    handleInput(value) {
      this.$emit('input', value);
    },
    // 处理变更事件
    handleChange(event) {
      const code = event.target.value;
      const country = countries.find(item => item.code === code);
      this.$emit('change', {
        code,
        country,
      });
    },
    // 处理聚焦事件
    handleFocus(event) {
      this.$emit('focus', event);
    },
    // 处理失焦事件
    handleBlur(event) {
      this.$emit('blur', event);
    },
  },
  watch: {
    // 监听语言变化，更新国家列表
    lang() {
      this.initCountryList();
    },
  },
};
</script>

<style lang="scss" scoped>
.country-select-container {
  width: 100%;
}
</style>
